import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/globals.css';

import { PayPalScriptProvider } from '@paypal/react-paypal-js';


const initialOptions = {
  clientId: (import.meta.env.VITE_PAYMENT_MODE === "live" ? import.meta.env.VITE_PAYPAL_CLIENT_ID : import.meta.env.VITE_PAYPAL_SANDBOX_CLIENT_ID) as string,
  currency: 'USD', // Adjust if needed
  vault: true,
  intent: 'subscription',
};


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PayPalScriptProvider options={initialOptions}>
      <App />
    </PayPalScriptProvider>
  </React.StrictMode>
);

